// Presentation only: no storage, tracking, form submission or consent changes.
(() => {
  const mobile = matchMedia('(max-width:749px)');
  let elapsed = false;
  let engaged = false;
  let started = false;
  function update() {
    const scroller = document.querySelector('.page-wrapper');
    const distance = Math.max(window.scrollY, scroller?.scrollTop || 0);
    if (distance >= Math.min(300, innerHeight * 0.4)) engaged = true;
    if (elapsed && engaged) {
      document.body.setAttribute('data-fango-newsletter-ready', '');
      document.removeEventListener('scroll', update, true);
    }
  }
  // Desktop invitations retain their existing timing and native app behavior.
  function start() {
    if (!mobile.matches || started) return;
    started = true;
    document.addEventListener('scroll', update, { passive: true, capture: true });
    setTimeout(() => { elapsed = true; update(); }, 20000);
    update();
  }
  mobile.addEventListener('change', start);
  start();
})();
